import { Component } from "@kluntje/core";
import { HIDDEN, ANIMATING } from "Helper/cssClasses";
import { addClass, removeClass } from "@kluntje/js-utils/lib/dom-helpers";

class FRAFloatingButton extends Component {
  constructor() {
    super({});
  }

  afterComponentRender(): void {
    removeClass(this, HIDDEN);
    this.showInitialAnimation();
  }

  /**
   * if button is shown for the first time, show animation (only once)
   */
  showInitialAnimation(): void {
    setTimeout(() => addClass(this, ANIMATING), 300); // wait for fade-in-animation
  }
}

customElements.define("fra-m-floating-button", FRAFloatingButton);

export default FRAFloatingButton;
